import React, { useEffect} from "react";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getAccessGroupList, doAccessGroupDelete } from "../../../../redux/accessgroup/accessGroupState";
import { handleTableChange } from "../../../../utils/index";
import SearchFilter from "components/search/SearchFilter";
import { getAccessGroupLevelName } from "../../../../utils/index";

const AccessGroupTable = ({ recordList, pagination, doSearch, filters, doDelete, ...props }) => {
  	const columns = [
		{
	        title: `Group Name`,
	        dataIndex: 'agr_name',
	        key: 'agr_name',
	        width: '30%',
	        render:(agr_name) => <span>{agr_name}</span> 
	    },
		{
	        title: `Access Level`,
	        dataIndex: 'agr_level',
	        key: 'agr_level',
	        width: '15%',
	        render:(agr_level) => <span>{getAccessGroupLevelName(agr_level)}</span>
	    },
	    {
	        title: `Users`,
	        dataIndex: 'user_count',
	        key: 'user_count',
	        width: '10%',
	        render:(user_count) => <span>{user_count}</span>
	    },
		{
	        title: `Description`,
	        dataIndex: 'description',
	        key: 'description',
	        width: '33%',
	        render:(description) => <span>{description}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/access-groups/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'agr_id',
	        key: 'agr_id',
	        width: '12%',
	        render:(agr_id) => <CrudOption baseRoute="/console/access-groups" recordId={agr_id} deleteHandler={doDelete}/>
	    },
    ];
    
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
			<div className="py-2">
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
			</div>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.agr_id}
					scroll={{ x: "max-content" }}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}               	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.accessGroup.accessGroupList?.items,
  	pagination: state.accessGroup.accessGroupList?.pagination,
	filters: state.accessGroup.accessGroupList?.filters,
  	requesting: state.accessGroup.accessGroupList?.requesting,
  	error: state.accessGroup.accessGroupList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getAccessGroupList(filters)),
  	doDelete: (id) => dispatch(doAccessGroupDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessGroupTable);